<template>
<div></div>
</template>

<script>
import * as THREE from 'three'
export default {
  props: {
    texture: {
      default () {
        return `
          data:image/svg+xml;utf8,
          <svg width="171px" height="128px" viewBox="0 0 171 128" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs></defs>
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="iconmonstr-picture-1-(2)" fill="#ff00ff" fill-rule="nonzero">
                      <path d="M35.5555556,39.1111111 C35.5555556,33.2231111 40.3342222,28.4444444 46.2222222,28.4444444 C52.1102222,28.4444444 56.8888889,33.2231111 56.8888889,39.1111111 C56.8888889,45.0062222 52.1102222,49.7777778 46.2222222,49.7777778 C40.3342222,49.7777778 35.5555556,45.0062222 35.5555556,39.1111111 Z M99.5555556,42.6666667 L81.6426667,71.1111111 L64,57.1733333 L35.5555556,99.5555556 L135.111111,99.5555556 L99.5555556,42.6666667 Z M156.444444,14.2222222 L156.444444,113.777778 L14.2222222,113.777778 L14.2222222,14.2222222 L156.444444,14.2222222 Z M170.666667,0 L0,0 L0,128 L170.666667,128 L170.666667,0 Z" id="Shape"></path>
                  </g>
              </g>
          </svg>
        `
      }
    },
    width: {
      default () {
        return 100
      }
    },
    height: {
      default () {
        return 100
      }
    }
  },
  data () {
    return {
      mesh: false,
      aspect: 1
    }
  },
  watch: {
    width () {
      this.updateMesh()
    }
  },
  mounted () {
    var mesh = this.mesh = new THREE.Mesh()
    var geo = new THREE.PlaneBufferGeometry(this.width, this.height, 2, 2)
    var shader = new THREE.ShaderMaterial({
      vertexShader: require('./shader/simple.vert'),
      fragmentShader: require('./shader/simple.frag'),
      transparent: true,
      depthTest: true,
      uniforms: {
        texture: { value: new THREE.TextureLoader().load(this.texture, (texture) => {
          var img = texture.image
          var w = img.width
          var h = img.height
          var aspect = h / w
          this.aspect = aspect

          let geo = new THREE.PlaneBufferGeometry(this.width, this.width * aspect, 2, 2)
          mesh.geometry = geo

          this.$emit('element', this)
        }) }
      }
    })
    mesh.material = shader
    mesh.geometry = geo

    this.updateMesh = () => {
      let geo = new THREE.PlaneBufferGeometry(this.width, this.width * this.aspect, 2, 2)
      mesh.geometry = geo
    }

    this.shader = shader

    this.$parent.$emit('add', mesh)
    this.clean = () => {
      this.$parent.$emit('remove', mesh)
    }
  },
  beforeDestroy () {
    this.clean()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Parts/BackgroundImage/BackgroundImage.vue